// Vue plugin <eui-mermeny>:

import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';

import euiBurgare from 'v-components/euiBurgare';
import euiPopUpMeny from 'v-components/euiPopUpMeny';

// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-mermeny',

	// -anim-scale-in"
	template: `
		<div
			class="_eui-mermeny"
			:class="{
				['-ikon-av-' + vpBurgareIkonAv]:vpBurgareIkonAv,
				['-ikon-pa-' + vpBurgareIkonPa]:vpBurgareIkonPa,
				'-med-etikett':harText,
				'-etikett-till-hoger':harText && vpEtikettTillHoger,
				'-etikett-till-vanster':harText && !vpEtikettTillHoger,
				'-uthangande-sidor':vpUthangandeSidor,
				'-inaktiverad':skaVaraInaktiverad,
				'-osynlig':skaVaraOsynlig
			}"
			:disabled="skaVaraInaktiverad"
		>
			<!-- ####### Burgaren: -->

			<template v-if="this.$slots.vidElementet" class="_eui-burgare_vid-element">
				<slot name="vidElementet"></slot>
			</template>

			<eui-burgare v-if="!this.$slots.vidElementet"
				:id="uniktIdBurgaren"
				ref="burgaren"
				v-model="visaMermenyn"
				:vp-ikon-av="vpBurgareIkonAv"
				:vp-ikon-av-storlek="vpBurgareIkonAvStorlek"
				:vp-ikon-pa="vpBurgareIkonPa"
				:vp-ikon-pa-storlek="vpBurgareIkonPaStorlek"
				:vp-etikett-till-hoger="vpEtikettTillHoger"
			>
				<slot></slot>
			</eui-burgare>

			<!-- ####### Menyn: -->

			<!-- .sync nedan gör att denna komponent lyssnar på eventet 'update:vpVisaMenyn' och då ändrar värdet på visaMermenyn: -->
			<!-- .sync nedan gör att denna komponent lyssnar på eventet 'update:vpDoljMenynLangsamt' och då ändrar värdet på doljMermenynLangsamt: -->
			<eui-pop-up-meny v-if="visaMermenyn"
				:vp-meny-stack="$root.popUpMenyStack"
				:vp-meny-config.sync="menyConfig"
				:vp-visa-menyn.sync="visaMermenyn"
				:vp-dolj-menyn-langsamt.sync="doljMermenynLangsamt"
				:vp-vid-element-query-selector="'#' + uniktIdBurgaren"
				@menyalternativ-valt-i-pop-up-meny="onMenyalternativValtIPopUpMeny"
			>
				<template #pop-up-menyhuvud>
					<slot name="menyhuvud"></slot>
				</template>

			</eui-pop-up-meny>

		</div>
	`,

	components: {
		[euiBurgare.component.name]: euiBurgare.component,
		[euiPopUpMeny.name]: euiPopUpMeny
	},

	mixins: [ euiLifecycleStatusesMixin ],

	props: {

		vpBurgareIkonAv: {
			type: String,
			// Default följer diton i eui-burgare: default: 'burgarePunkter',
		},
		vpBurgareIkonAvStorlek: {
			type: String,
			// Default följer diton i eui-burgare: default: '1.7rem',
		},

		vpBurgareIkonPa: {
			type: String,
			// Default följer diton i eui-burgare: default: 'stang',
		},
		vpBurgareIkonPaStorlek: {
			type: String,
			// Default följer diton i eui-burgare: default: undefined,		// undefined => samma storlek som vpIkonAvStorlek
		},

		vpEtikettTillHoger: {
			type: Boolean,
			default: true,
		},

		vpUthangandeSidor: {
			type: Boolean,
			default: false,
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpMenyConfig':
		vpMenyConfig: {
			type: [euiPopUpMenyClasses.menyConfig, Object],
			required: true,
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpVisaMermenyn':
		vpVisaMermenyn: {
			type: Boolean,
			default: false
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpVisaMermenyn':
		vpDoljMermenynLangsamt: {
			type: Boolean,
			default: false
		},

		vpInaktiverad: {
			type: Boolean,
			default: false
		},
		vpOsynlig: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			menyConfig: this.vpMenyConfig,

			uniktId: 'eui-mermeny-unikt-' + (++uniktIdCounter),
			uniktIdBurgaren: 'eui-mermeny-unikt-' + uniktIdCounter + '-burgaren',
			visaMermenyn: false,
			doljMermenynLangsamt: false,
		};
	},

	computed: {
		harText() {
			return this.$slots.default != undefined;
		},

		skaVaraOsynlig() {
			return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedAndNextTickHasOccured);	//AndSecondNextTickHasOccured);
		},

		skaVaraInaktiverad() {
			return (this.vpInaktiverad);				// || !this.lifecycleStatuses.mixinMountedAndSecondNextTickHasOccured);
		},
	},

	watch: {

		vpVisaMermenyn(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggar *inte* vid initial rendering med värdet true!
			this.visaMermenyn = nyttVarde;
		},

		visaMermenyn(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggar *inte* vid initial rendering med värdet true!
			// Propen används med .sync i parent component:
			this.$emit('update:vpVisaMermenyn', nyttVarde);
		},

		vpDoljMermenynLangsamt(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggar *inte* vid initial rendering med värdet true!
			this.doljMermenynLangsamt = nyttVarde;
		},

		doljMermenynLangsamt(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggar *inte* vid initial rendering med värdet true!
			// Propen används med .sync i parent component:
			this.$emit('update:vpDoljMermenynLangsamt', nyttVarde);
		},

		vpMenyConfig: {
			// Obs! Denna watch är "deep"!
			handler(nyttVarde, tidigareVarde)
			{
				this.menyConfig = nyttVarde;
			},
			deep: true,
		},

		menyConfig: {
			// Obs! Denna watch är "deep"!
			handler(nyttVarde, tidigareVarde)
			{
				// Propen används med .sync i parent component:
				this.$emit('update:vpMenyConfig', nyttVarde);
			},
			deep: true,
		},
	},

	methods: {
		onMenyalternativValtIPopUpMeny({ eventId, eventData }) {

			this.$emit('menyalternativ-valt-i-mermeny',
				// Payload:
				{ eventId: eventId, eventData: eventData }
			);
		},
	},

	//created() {
	//	// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
	//	// Exempel: this.$_undertryckNastaAndradEvent = false;
	//},

	//mounted() {
	//	// Note that mounted does not guarantee that all child components have also been mounted.
	//	//-----------------------------------------------------------------------------------------------------------------------
	//	// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
	//	//
	//	// 1. Mixins mounted hook.
	//	// 2. Appens/komponentens mounted hook.
	//	//
	//	// 3. Mixins mounted hook + nextTick (DOM not updated yet).
	//	// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
	//	//
	//	// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
	//	// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
	//	//
	//	// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
	//	//
	//	// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
	//	// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
	//	// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
	//	//-----------------------------------------------------------------------------------------------------------------------
	//	//console.log('mounted: mermeny', this.uniktId);

	//	//## 2. Appens/komponentens mounted hook:  #################################
	//	//console.log('2. Appens/komponentens mounted hook');

	//	this.$nextTick(function () {
	//		// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
	//		// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

	//		//## 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet):  #################################
	//		//console.log('4. Appens/komponentens mounted hook + nextTick');
	//	});
	//},

	//beforeUpdate()
	//{
	//	// Called when data changes, before the DOM is patched. This is a good place to access the existing DOM before an update, e.g. to remove manually added event listeners.
	//	// This hook is not called during server-side rendering, because only the initial render is performed server-side.
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
	//	// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//	console.log('beforeUpdate: mermeny', this.uniktId);
	//},

	//updated()
	//{
	//	// Called after a data change causes the virtual DOM to be re-rendered and patched.
	//	// The component’s DOM will have been updated when this hook is called, so you can perform DOM-dependent operations here. However, in most cases you should avoid changing state inside the hook. To react to state changes, it’s usually better to use a computed property or watcher instead.
	//	// This hook is not called during server-side rendering.
	//	// Note that updated does not guarantee that all child components have also been re-rendered.
	//	// Denna hook körs även efter mounted!
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
	//	// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//	console.log('updated: mermeny', this.uniktId);

	//	this.$nextTick(function () {
	//		// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
	//		// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:
	//	});
	//},

	//activated()
	//{
	//	// Called when a *kept-alive* component is activated.
	//	// This hook is not called during server-side rendering.
	//},

	//deactivated()
	//{
	//	// Called when a *kept-alive* component is deactivated.
	//	// This hook is not called during server-side rendering.
	//},

	//beforeDestroy()
	//{
	//	// Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
	//	// This hook is not called during server-side rendering.
	//	//console.log('beforeDestroy: mermeny', this.uniktId);
	//},

	//destroyed()
	//{
	//	// Called after a Vue instance has been destroyed. When this hook is called, all directives of the Vue instance have been unbound, all event listeners have been removed, and all child Vue instances have also been destroyed.
	//	// This hook is not called during server-side rendering.
	//	//console.log('destroyed: mermeny', this.uniktId);
	//},
};
